import React, { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../Components/Firebase"; // Adjust path as needed
import '../Styles/Sapakim/SCatalog.css';
import SapakimHead from "./SapakimHead";
import { useNavigate, useParams } from "react-router-dom";

function SCatalog() {
    const [catalogs, setCatalogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const nav = useNavigate()
    const {UID} = useParams()
    // Fetch catalogs from Firebase
    useEffect(() => {
        fetchCatalogs();
    }, []);

    const fetchCatalogs = async () => {
        try {
            setLoading(true);
            setError(null);
            const catalogsCollection = collection(db, "Catalog");
            const querySnapshot = await getDocs(catalogsCollection);
            const catalogsData = [];
            
            querySnapshot.forEach((doc) => {
                catalogsData.push({ 
                    id: doc.id, 
                    ...doc.data() 
                });
            });
            
            setCatalogs(catalogsData);
        } catch (error) {
            console.error("Error fetching catalogs:", error);
            setError("שגיאה בטעינת הקטלוגים");
        } finally {
            setLoading(false);
        }
    };

    // Handle catalog click
    const handleCatalogClick = (catalogId) => {
        // Navigate to catalog items or handle click as needed
        console.log("Clicked catalog:", catalogId);
        // You can add navigation logic here
        // For example: navigate(`/catalog/${catalogId}`)
    };

    if (loading) {
        return (
            <React.Fragment>
                <SapakimHead />
                <div className="scatalog-container">
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <p>טוען קטלוגים...</p>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    if (error) {
        return (
            <React.Fragment>
                <SapakimHead />
                <div className="scatalog-container">
                    <div className="error-container">
                        <div className="error-icon">⚠️</div>
                        <p>{error}</p>
                        <button onClick={fetchCatalogs} className="retry-btn">
                            נסה שוב
                        </button>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <SapakimHead />
            <div className="scatalog-container">
                <div className="catalog-header">
                    <h1>קטלוג סוכן</h1>
                    <p>בחר קטגוריה לצפייה בפריטים</p>
                </div>

                {catalogs.length === 0 ? (
                    <div className="no-catalogs">
                        <div className="no-catalogs-icon">📁</div>
                        <h3>אין קטלוגים זמינים</h3>
                        <p>לא נמצאו קטלוגים במערכת</p>
                    </div>
                ) : (
                    <div className="catalogs-grid">
                        {catalogs.map((catalog) => (
                            <div 
                                key={catalog.id} 
                                className="catalog-card"
                                onClick={() => handleCatalogClick(catalog.id)}
                            >
                                <div className="catalog-card-header">
                                    <div className="catalog-icon">
                                        {catalog.icon || "📋"}
                                    </div>
                                </div>
                                
                                <div className="catalog-card-body">
                                    <h3 className="catalog-name">
                                        {catalog.name || catalog.id}
                                    </h3>
                                </div>
                                
                                <div className="catalog-card-footer">
                                    <button className="view-catalog-btn" onClick={() => {nav(`/SapakimHome/${UID}/SCatalog/${catalog.id}`)}}>
                                        צפה בקטלוג
                                        <span className="arrow">←</span>
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                
                <div className="catalog-stats">
                    <div className="stat-item">
                        <span className="stat-number">{catalogs.length}</span>
                        <span className="stat-label">קטלוגים זמינים</span>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default SCatalog;